"use client";

import React from "react";
import { ArrowRight, ClipboardCheck, FileText } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Hero() {
  const shouldReduceMotion = useReducedMotion();
  const transitionConfig = {
    duration: shouldReduceMotion ? 0 : 0.3,
    ease: [0.16, 1, 0.3, 1] as [number, number, number, number]
  };
  return <section id="hero" data-nav="light" className="relative w-full border-b border-border bg-background py-16 md:py-24">
      {/* Blueprint datum lines */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute top-0 left-6 h-3 w-px bg-foreground/20 md:left-12" />
        <div className="absolute top-0 right-6 h-3 w-px bg-foreground/20 md:right-12" />
        <div className="absolute bottom-0 left-6 h-3 w-px bg-foreground/20 md:left-12" />
        <div className="absolute bottom-0 right-6 h-3 w-px bg-foreground/20 md:right-12" />
      </div>

      <div className="container mx-auto px-5 sm:px-8 lg:px-12 max-w-7xl">
        <div className="flex w-full flex-col items-start text-left">
          {/* Classification Eyebrow */}
          <motion.div initial={shouldReduceMotion ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={transitionConfig} className="inline-flex items-center gap-2 border border-border bg-muted px-3 py-1.5 text-xs font-mono uppercase tracking-wider text-foreground mb-6">
            <ClipboardCheck className="size-4 text-primary" />
            <span>PRE-OWNED MECHANICAL BULLS</span>
          </motion.div>

          {/* Dictated H1 Heading */}
          <motion.h1 initial={shouldReduceMotion ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          ...transitionConfig,
          delay: shouldReduceMotion ? 0 : 0.06
        }} className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold uppercase tracking-tight text-foreground leading-[1.05]">
            Used Mechanical Bulls for Sale
          </motion.h1>

          {/* Supporting Paragraph */}
          <motion.p initial={shouldReduceMotion ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          ...transitionConfig,
          delay: shouldReduceMotion ? 0 : 0.12
        }} className="mt-6 text-base sm:text-lg text-muted-foreground font-sans leading-relaxed max-w-2xl">
            Buying a used mechanical bull for sale can reduce the initial cost of ownership, but only when you understand the condition of the exact machine you are considering. Mechanical Bull Shop organizes pre-owned equipment around unit-specific information so buyers can compare price, condition, included equipment and available history before making an enquiry.
          </motion.p>

          {/* Action Buttons */}
          <motion.div initial={shouldReduceMotion ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          ...transitionConfig,
          delay: shouldReduceMotion ? 0 : 0.18
        }} className="mt-8 flex flex-wrap gap-4 items-center">
            <Button asChild className="rounded-lg border border-primary bg-primary text-primary-foreground font-serif uppercase tracking-wider text-base font-semibold px-6 py-6 hover:bg-primary/90 transition-[background-color,border-color]">
              <Link to="#product-catalog">
                View Used Bulls
                <ArrowRight className="size-4 ml-1" />
              </Link>
            </Button>

            <Button asChild variant="outline" className="rounded-lg border border-foreground bg-transparent text-foreground font-serif uppercase tracking-wider text-base font-semibold px-6 py-6 hover:bg-foreground hover:text-background transition-[background-color,color]">
              <Link to="/MechanicalBullBuyingGuidePage">
                <FileText className="size-4 mr-1" />
                Read Buying Guide
              </Link>
            </Button>
          </motion.div>
        </div>
      </div>
    </section>;
}